module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_c('i', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("EXPRESSIONS OF LOVE: A Novel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_vm._v("Part One: September, 1980")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_vm._v("Part Two: October, 1941")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: May, 1981")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A MASK OF ONE’S OWN:")]), _vm._v(" A Novel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter One: 1950–1951")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two: Autumn, 1981")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three: Winter, 1959–1960")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four: Spring, 1982")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five: Autumn, 1961")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: Autumn, 1982")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: Winter, 1982–1983")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: Spring, 1983")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: Summer, 1983")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten: Autumn, 1983")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EXPRESSIONS OF LOVE (conclusion)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: January, 1986")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Five: October, 1983")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Six: June, 1986")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0